<template>
  <b-container fluid>
    <iq-card>
      <template v-slot:headerTitle>
        <h4 class="card-title">{{ $t('retailerManagement.quotation_request_approve') }}</h4>
      </template>
      <template v-slot:body>
        <b-row>
            <b-col xs="12" sm="12" md="6" lg="4" xl="4">
                <b-form-group
                    class="row"
                    label-cols-sm="4"
                    :label="$t('retailerManagement.fiscal_year')"
                    label-for="fiscal_year_id"
                    >
                    <b-form-select
                    plain
                    v-model="productget.fiscal_year"
                    :options="fiscalYearList"
                    id="fiscal_year_id"
                    >
                    <template v-slot:first>
                        <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                    </template>
                    </b-form-select>
                </b-form-group>
            </b-col>
             <b-col xs="12" sm="12" md="6" lg="4" xl="4">
                <b-form-group
                    class="row"
                    label-cols-sm="4"
                    :label="$t('retailerManagement.month')"
                    label-for="month_id"
                    >
                    <b-form-select
                    plain
                    v-model="search.month_id"
                    :options="monthList"
                    id="month_id"
                    >
                    <template v-slot:first>
                        <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                    </template>
                    </b-form-select>
                </b-form-group>
            </b-col>
            <b-col xs="12" sm="12" md="6" lg="4" xl="4">
                <b-form-group
                    class="row"
                    label-cols-sm="4"
                    :label="$t('retailerManagement.quotation_type')"
                    label-for="type_id"
                    >
                    <b-form-select
                    plain
                    v-model="search.type_id"
                    :options="registrationTypeList"
                    id="type_id"
                    >
                    <template v-slot:first>
                        <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                    </template>
                    </b-form-select>
                </b-form-group>
            </b-col>
            <b-col xs="12" sm="12" md="6" lg="4" xl="4">
                <b-form-group
                    class="row"
                    label-cols-sm="4"
                    :label="$t('globalTrans.name')"
                    label-for="user_id"
                    >
                    <v-select name="user_id"
                    v-model="search.user_id"
                    label="text"
                    :reduce="item => item.value"
                    :options="agentNameList"
                    :placeholder="$t('globalTrans.select')"
                    :filter-by="myFilter"
                    />
                </b-form-group>
            </b-col>
           <b-col xl="4" lg="4" md="6" sm="12" xs="12">
                <b-form-group
                    class="row"
                    label-cols-sm="4"
                    label-for="date_from"
                >
                    <template v-slot:label>
                        {{$t('retailerManagement.delivery_date_from')}}
                    </template>
                    <b-form-input class="form-control"
                        v-model="search.date_from"
                        placeholder="Select Date"
                        id="date_from"
                    ></b-form-input>
                </b-form-group>
            </b-col>
            <b-col xl="4" lg="4" md="6" sm="12" xs="12">
                <b-form-group
                    class="row"
                    label-cols-sm="4"
                    label-for="date_to"
                >
                    <template v-slot:label>
                        {{$t('retailerManagement.delivery_date_to')}}
                    </template>
                    <b-form-input class="form-control"
                        v-model="search.date_to"
                        placeholder="Select Date"
                        id="date_to"
                    ></b-form-input>
                </b-form-group>
            </b-col>
             <b-col cols="12" class="text-right">
              <b-button type="button" variant="primary" @click="searchData">{{ $t('globalTrans.search') }}</b-button>
              </b-col>
        </b-row>
      </template>
    </iq-card>
    <b-row>
      <b-col md="12">
        <iq-card>
          <template v-slot:headerTitle>
            <h4 class="card-title">{{ $t('retailerManagement.quotation_approve_list') }}</h4>
          </template>
          <template v-slot:body>
            <b-overlay :show="loadingState">
              <b-row>
                <b-col md="12" class="table-responsive">
                  <b-table thead-class="bg-primary" bordered hover :items="listData" :fields="columns" aria-hidden="loading | listReload ? 'true' : null" :emptyText="$t('globalTrans.noDataFound')" show-empty>
                      <template v-slot:cell(index)="data">
                        {{ $n(data.index + pagination.slOffset) }}
                      </template>
                      <template v-slot:cell(demmand_date)="data">
                        <span class="capitalize">{{ data.item.main_quotation.demand.demmand_date | dateFormat }}</span>
                      </template>
                      <template v-slot:cell(quotation_id)="data">
                        <span class="capitalize" v-if="data.item.main_quotation.demand.demmand_type === 1"> {{ 'P - ' }} {{ data.item.main_quotation.quotation_id }}</span>
                        <span class="capitalize" v-else>{{ 'W - ' }} {{ data.item.main_quotation.quotation_id }}</span>
                      </template>
                      <template v-slot:cell(name)="data">
                        <span class="capitalize">{{ data.item.name }}</span>
                      </template>
                      <template v-slot:cell(est_delivery_date)="data">
                        <span class="capitalize">{{ data.item.main_quotation.demand.est_delivery_date | dateFormat }}</span>
                      </template>
                      <template v-slot:cell(status)="data">
                          <span class="badge badge-warning" v-if="data.item.status == 1">
                              {{ $t('globalTrans.pending') }}
                          </span>
                          <span class="badge badge-warning" v-else-if="data.item.status == 2">
                            {{ currentLocale === 'bn' ?  getNameReceiver(data.item.forward_request.receiver_id) + ' দ্বারা ' + $t('globalTrans.pending') : $t('globalTrans.pending') + ' By ' + getNameReceiver(data.item.forward_request.receiver_id) }}
                          </span>
                          <span class="badge badge-success" v-else-if="data.item.status == 3">
                              {{$t('globalTrans.approve')}}
                          </span>
                           <span class="badge badge-success" v-else-if="data.item.status == 5">
                              {{$t('globalTrans.forward_to_nothi')}}
                          </span>
                          <span class="badge badge-danger" v-else> {{$t('globalTrans.rejected')}} </span>
                      </template>
                      <template v-slot:cell(action)="data">
                        <a href="javascript:" class="btn_table_action btn_green" v-b-modal.modal-detail @click="view(data.item)" :title="$t('globalTrans.details')"><i class="fas fa-eye"></i></a>
                          <span v-if="data.item.status == 1">
                              <b-button v-if="$store.state.Auth.authUser.ssoLogin" style="font-size: 12px !important; margin-top:10px" variant="btn btn-xs btn-success" size="sm" @click="finalSave(data.item)" ><i class="fa fa-forward"></i> {{$t('globalTrans.to_nothi')}}</b-button>
                              <a href="javascript:" class="btn_table_action btn_purple" v-b-modal.modal-2 @click="forward(data.item)" :title="$t('globalTrans.forward')"><i class="fas fa-forward"></i></a>
                              <a href="javascript:" class="btn_table_action btn_blue" @click="approveDeny(data.item, status=1)" :title="$t('globalTrans.approve')"><i class="fas fa-check"></i></a>
                              <a href="javascript:" class="btn_table_action btn_deep_blue" @click="approveDeny(data.item, status=2)" :title="$t('retailerManagement.deny')"><i class="fa fa-ban"></i></a>
                          </span>
                      </template>
                  </b-table>
                  <b-pagination
                    v-model="pagination.currentPage"
                    :per-page="pagination.perPage"
                    :total-rows="pagination.totalRows"
                    @input="searchData"
                    />
                </b-col>
              </b-row>
            </b-overlay>
          </template>
        </iq-card>
      </b-col>
    </b-row>
      <b-modal id="modal-detail" size="lg" :title="formTitle" :ok-title="$t('globalTrans.close')" ok-only ok-variant="danger">
          <DetailModal :id="forwardId" :demandType="demandType" :userList="userList" />
      </b-modal>
        <b-modal id="modal-2" size="lg" :title="$t('production_store.forward')" :ok-title="$t('globalTrans.close')" ok-only ok-variant="danger">
            <p>
                <FormForward :id="forwardId" />
            </p>
        </b-modal>
  </b-container>
</template>
<script>
import FormForward from './Forward'
import DetailModal from './DetailModal'
import { mapGetters } from 'vuex'
import RestApi, { productionServiceBaseUrl, commonServiceBaseUrl } from '@/config/api_config'
import { quotationRequestListApi, fiscalYearData, quotationApproveDenyApi, quotationRequestSendNothi } from '../../api/routes'
import ModalBaseMasterList from '@/mixins/modal-base-master-list'
import flatpickr from 'flatpickr'
import Store from '@/store'

export default {
  mixins: [ModalBaseMasterList],
   components: {
    FormForward, DetailModal
  },
  data () {
    return {
      search: {
        fiscal_year_id: 0,
        fis_start_date: 0,
        fis_end_date: 0,
        date_from: '',
        date_to: '',
        month_id: 0,
        type_id: 0,
        user_id: ''
      },
      productget: {
        fiscal_year: 0
      },
      rows: [],
      agentNameList: [],
      forwardId: '',
      userList: [],
      demandType: ''
    }
  },
  computed: {
    formTitle () {
       return this.$t('retailerManagement.demand') + ' ' + this.$t('retailerManagement.details')
    },
    quotationTitle () {
       return this.$t('retailerManagement.quotation_entry')
    },
    fiscalYearList: function () {
      return this.$store.state.commonObj.fiscalYearList.filter(item => item.status === 0).sort((a, b) => b.value - a.value).slice(0, 3)
    },
    monthList () {
      const objectData = this.$store.state.commonObj.monthList
      return objectData.map((obj, key) => {
        if (this.$i18n.locale === 'bn') {
          return { value: obj.value, text: obj.text_bn }
        } else {
          return { value: obj.value, text: obj.text_en }
        }
      })
    },
    registrationTypeList: function () {
        const list = [
          { value: 1, text: 'Retailer' },
          { value: 2, text: 'Dealer' }
        ]
        const listbn = [
          { value: 1, text: 'খুচরা বিক্রেতা' },
          { value: 2, text: 'ব্যবসায়ী' }
        ]
        return this.$i18n.locale === 'bn' ? listbn : list
    },
    currentLocale () {
      return this.$i18n.locale
    },
    columns () {
      const labels = [
          { label: this.$t('globalTrans.sl_no'), class: 'text-center' },
          { label: this.$t('retailerManagement.demand_order_date'), class: 'text-center' },
          { label: this.$t('retailerManagement.quotation_id'), class: 'text-left' },
          { label: this.$t('retailerManagement.demand_by'), class: 'text-center' },
          { label: this.$t('retailerManagement.delivery_date'), class: 'text-center' },
          { label: this.$t('globalTrans.status'), class: 'text-center' },
          { label: this.$t('globalTrans.action'), class: 'text-center' }
        ]

      let keys = []

      if (this.$i18n.locale === 'bn') {
        keys = [
          { key: 'index' },
          { key: 'demmand_date' },
          { key: 'quotation_id' },
          { key: 'name_bn' },
          { key: 'est_delivery_date' },
          { key: 'status' },
          { key: 'action' }
        ]
      } else {
        keys = [
         { key: 'index' },
          { key: 'demmand_date' },
          { key: 'quotation_id' },
          { key: 'name' },
          { key: 'est_delivery_date' },
          { key: 'status' },
          { key: 'action' }
        ]
      }

      return labels.map((item, index) => {
          return Object.assign(item, keys[index])
        })
    },
    ...mapGetters({
      productCommonObj: 'ProductionService/commonObj'
    })
  },
  watch: {
    'productget.fiscal_year': function (newVal) {
      RestApi.getData(commonServiceBaseUrl, `${fiscalYearData}/${newVal}`).then(response => {
        this.search.fiscal_year_id = response.data.id
        this.search.fis_start_date = response.data.start_date
        this.search.fis_end_date = response.data.end_date
      })
    },
    'search.type_id': function (newVal, oldVal) {
          if (newVal !== oldVal) {
              this.agentNameList = this.getDealerRetailerListByType(newVal)
          }
      }
  },
  created () {
    this.loadData()
  },
  mounted () {
     flatpickr('#date_from', {})
     flatpickr('#date_to', {})
  },
  methods: {
    myFilter: (option, text, search) => {
        const temp = search.toLowerCase()
        return option.text_en.toLowerCase().indexOf(temp) > -1 ||
        option.text_bn.toLowerCase().indexOf(temp) > -1
    },
    forward (item) {
        this.forwardId = item.id
    },
    view (item) {
        this.forwardId = item.main_quotation.id
        this.demandType = item.main_quotation.demand.demmand_type
    },
    searchData () {
      this.loadData()
    },
    getNameReceiver (id) {
        const userData = this.userList.find(user => user.value === id)
        if (this.$i18n.locale === 'bn') {
          return userData.text_bn
        } else {
            return userData.text_en
        }
    },
    finalSave (item) {
      this.toggleStatusCustom2(productionServiceBaseUrl, quotationRequestSendNothi, item)
    },
    toggleStatusCustom2 (baseUrl, uri, item) {
      window.vm.$swal({
        title: window.vm.$t('globalTrans.are_you_sure_forward_to_nothi'),
        showCancelButton: true,
        confirmButtonText: window.vm.$t('globalTrans.yes'),
        cancelButtonText: window.vm.$t('globalTrans.no'),
        focusConfirm: false
      }).then((result) => {
        if (result.isConfirmed) {
          this.changeStatusCustom(baseUrl, uri, item)
        }
      })
    },
    changeStatusCustom (baseUrl, uri, item) {
      Store.dispatch('mutateCommonProperties', { loading: true, listReload: false })
      RestApi.postData(baseUrl, uri, item).then(response => {
        if (response.success) {
          window.vm.$toast.success({
            title: 'Success',
            message: 'Data Updated Successfully',
            color: '#D6E09B'
          })
        } else {
          window.vm.$toast.error({
            title: 'Error',
            message: 'Operation failed! Please, try again.'
          })
        }
        Store.dispatch('mutateCommonProperties', { loading: false, listReload: true })
      })
    },
    approveDeny (item, status) {
        let swalMsg = ''
        if (status === 1) {
            swalMsg = window.vm.$t('production_store.approve')
        } else {
            swalMsg = window.vm.$t('production_store.deny')
        }
        window.vm.$swal({
            title: swalMsg,
            showCancelButton: true,
            confirmButtonText: window.vm.$t('globalTrans.yes'),
            cancelButtonText: window.vm.$t('globalTrans.no'),
            focusConfirm: false
        }).then((result) => {
            if (result.isConfirmed) {
                this.$store.dispatch('mutateCommonProperties', { loading: true })
                const loadingState = { loading: false, listReload: true }
                if (item.id) {
                    RestApi.putData(productionServiceBaseUrl, `${quotationApproveDenyApi}/${item.id}/${status}`).then(response => {
                    this.$store.dispatch('mutateCommonProperties', loadingState)
                        if (response.success) {
                            if (response.notification && this.$store.state.emitNotification) {
                                const notification = response.notification
                                this.$socket.emit('send-notification', notification)
                            }
                            // it goes to external panel
                            if (response.notification2 && this.$store.state.emitNotification) {
                                const notification2 = response.notification2
                                this.$socket.emit('send-notification', notification2)
                            }
                            this.$store.commit('ProductionService/mutateCommonObj', { hasDropdownLoaded: false })
                            this.$toast.success({
                                title: this.$t('globalTrans.success'),
                                message: this.id ? this.$t('globalTrans.update_msg') : this.$t('globalTrans.save'),
                                color: '#D6E09B'
                            })
                        } else {
                            this.$refs.form.setErrors(response.errors)
                        }
                    })
                }
            }
        })
    },
    loadData () {
      const params = Object.assign({}, this.search, { page: this.pagination.currentPage, per_page: this.pagination.perPage })
      this.$store.dispatch('mutateCommonProperties', { loading: true, listReload: false })
      RestApi.getData(productionServiceBaseUrl, quotationRequestListApi, params).then(response => {
          if (response.success) {
            this.userList = response.userDetails
            this.$store.dispatch('setList', this.getRelationalData(response.data.data))
            this.paginationData(response.data)
          }
          this.$store.dispatch('mutateCommonProperties', { loading: false, listReload: false })
      })
    },
    getRelationalData (data) {
        const listData = data.map(item => {
            const tmpName = this.productCommonObj.dealerRetailerList.find(user => user.value === item.main_quotation.demand.demmand_user_id)
            const nameData = {
                name: tmpName !== undefined ? tmpName.text_en : '',
                name_bn: tmpName !== undefined ? tmpName.text_bn : ''
            }
            return Object.assign({}, item, nameData)
        })
        return listData
    },
    getDealerRetailerListByType (typeId) {
        return this.productCommonObj.dealerRetailerList.filter(item => item.type === typeId)
    }
  }
}
</script>
